import { Grid, Paper, Box } from "@mui/material";
import React from "react";
import "../../Styles/strategy.css";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import HeaderIcons from "../../Images/headericon.png";
import AddAssets from "./addAssets";
import StrategyPerformance from "./StrategyPerformance";

function Index() {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid item xs={12}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={0}
        >
          <div className="row rows" style={{ marginLeft: "2px", alignItems: 'center' }}>
            <div className="col-auto" style={{ display: 'flex', alignItems: 'center' }}>
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>

            <div className="col-auto" style={{ display: 'flex', alignItems: 'center' }}>
              <p style={{ fontSize: "20px", color: "#18275A", margin: 0 }}>Add Strategy</p>
            </div>
          </div>
        </Paper>
        <br />
        <Box
          sx={{ width: "100%", typography: "body1" }}
          style={{
            height: "calc(100vh - 180px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <AddAssets />
        </Box>
      </Grid>
    </>
  );
}

export default Index;
